import { useDataValue } from 'Simple/Data.js'
import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let tags = useDataValue({
    context: 'event_action',
    path: 'data.tags',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    return data.sort((a, b) => (tags.some(tag => tag.id === a.id) ? -1 : 1))
  }, [data])
}
